
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"-27 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M188 492c0 11.047-8.953 20-20 20H80c-44.113 0-80-35.887-80-80V80C0 35.887 35.887 0 80 0h245.89c44.11 0 80 35.887 80 80v191c0 11.047-8.956 20-20 20-11.046 0-20-8.953-20-20V80c0-22.055-17.945-40-40-40H80c-22.055 0-40 17.945-40 40v352c0 22.055 17.945 40 40 40h88c11.047 0 20 8.953 20 20zm117.89-372h-206c-11.046 0-20 8.953-20 20s8.954 20 20 20h206c11.044 0 20-8.953 20-20s-8.956-20-20-20zm20 100c0-11.047-8.956-20-20-20h-206c-11.046 0-20 8.953-20 20s8.954 20 20 20h206c11.044 0 20-8.953 20-20zm-226 60c-11.046 0-20 8.953-20 20s8.954 20 20 20H205c11.047 0 20-8.953 20-20s-8.953-20-20-20zm355.473 146.496c-.703 1.004-3.113 4.414-4.61 6.3-6.698 8.427-22.378 28.15-44.194 45.56C378.586 500.68 349.8 512 321 512s-57.586-11.32-85.559-33.645c-21.816-17.41-37.496-37.136-44.191-45.558-1.5-1.887-3.91-5.3-4.613-6.3a20 20 0 010-22.997c.703-1 3.113-4.414 4.613-6.3 6.695-8.423 22.375-28.145 44.191-45.555C263.414 329.32 292.2 318 321 318s57.586 11.32 85.559 33.645c21.816 17.41 37.496 37.136 44.191 45.558 1.5 1.887 3.91 5.3 4.613 6.3a19.993 19.993 0 010 22.993zM413.645 415c-31.801-37.832-62.938-57-92.645-57-29.703 0-60.844 19.164-92.645 57 31.801 37.832 62.938 57 92.645 57s60.844-19.164 92.645-57zM322 377c-20.988 0-38 17.012-38 38s17.012 38 38 38 38-17.012 38-38-17.012-38-38-38zm0 0"}})])
          )
        }
      }
    